import axios from 'axios';

const backendUri = process.env.REACT_APP_BACKEND_URI;

// console.log("backend url",backendUri);

export const fetchTableData = async ({
  start_date,
  end_date,
  search_query = '',
  page = 1,
  expired = false,
  almost_expired = false,
  source_id 
}) => {
  try {
    const response = await axios.post(
      `${backendUri}/kpi/filterTable`,
      {
        start_date,
        end_date,
        search_query,
        page,
        expired,
        almost_expired,
        source_id
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching table data:', error);
    throw error;
  }
};

export const getCalendarData = async (body) => {
  try {
    const response = await axios.post(`${backendUri}/kpi/calendar`, body);
    return response;
  } catch (error) {
    console.error('Error in getCalendarData:', error);
    throw error;
  }
};
